import { Channel } from '@/types/channel.types';
import { GreenroomUpdateProfileMask, GreenroomUserProfile } from '@/types/greenroom/profile.types';
import { CreateSpeaker, Speaker } from '@/types/speakers.types';

const createUpdateGreenroomUserProfileMaskBody = ({
  workingSpeaker,
  greenroomProfile,
  userChannel,
}: {
  workingSpeaker: Speaker | CreateSpeaker;
  greenroomProfile: GreenroomUserProfile | null;
  userChannel: Channel;
}): GreenroomUpdateProfileMask | undefined => {
  if (!greenroomProfile || !greenroomProfile.gr_user) return;

  const updatedProfile = {
    avatar: workingSpeaker.image,
    email: greenroomProfile.email,
    first_name: workingSpeaker.first_name,
    last_name: workingSpeaker.last_name,
    title: workingSpeaker.job_title.base,
    location: workingSpeaker.location || '',
    bg_image: workingSpeaker.image,
    channel: userChannel?.channel,
  };

  return {
    entityId: '',
    entityType: 'profileMask',
    entityValue: updatedProfile,
  };
};

export default createUpdateGreenroomUserProfileMaskBody;
